import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import React, { useEffect, useRef } from 'react';

import { ScenarioInsightsLegacyDrawer } from './ScenarioInsightsLegacyDrawer';

export const ScenarioInsightsLegacyDrawerRender = () => {
  const { params } = useQueryParams();
  const { trackInsightsDrawerOpen } = usePosthogEvents();
  const trackedEntitiesRef = useRef<Set<string>>(new Set());

  const entityTagFromParams = params[queryKeys.entityTag];
  const activeDrawer = params[queryKeys.activeDrawer];
  const activeInsightId = params[queryKeys.activeInsightId];
  const utmSource = params[queryKeys.utmSource];

  const isDrawerOpen =
    entityTagFromParams &&
    activeDrawer === queryValues.insightsFullDrawer &&
    activeInsightId;

  useEffect(() => {
    if (!isDrawerOpen) {
      if (entityTagFromParams) {
        trackedEntitiesRef.current.clear();
      }

      return;
    }

    if (
      entityTagFromParams &&
      utmSource &&
      !trackedEntitiesRef.current.has(entityTagFromParams)
    ) {
      trackedEntitiesRef.current.add(entityTagFromParams);
      trackInsightsDrawerOpen(utmSource as PosthogTrackingSource, 'full', {});
    }
  }, [isDrawerOpen, entityTagFromParams, utmSource]);

  if (
    entityTagFromParams &&
    activeDrawer === queryValues.insightsFullDrawer &&
    activeInsightId
  ) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <ScenarioInsightsLegacyDrawer
          key={entityTagFromParams}
          entityTag={entityTagFromParams}
        />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
